import { Component } from '@verndale/core';
import Swiper from 'swiper/js/swiper';
import breakToLines from './breakToLines';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      el: this.el,
      slider: this.el.querySelector('.swiper-container'),
      items: [...this.el.querySelectorAll('.swiper-slide')],
      scrollbar: this.el.querySelector('.swiper-scrollbar'),
      swiperWrapper: this.el.querySelector('.swiper-wrapper')
    };

    this.originalWindowWidth = window.innerWidth;

    this.isPeopleSlider = this.el.dataset.isPeopleSlider === 'true';
    this.isHomeSlider = this.el.dataset.isHomeSlider === 'true';
    this.isScrollbar = this.el.dataset.progressbar === 'true';
    this.swiper;

    if (this.el.dataset.experienceEditor === 'true') {
      this.el.classList.add('experience-editor-slider');
      return this.initSwiperBreakToLines();
    }

    this.el.classList.remove('experience-editor-slider');

    if (this.el.dataset.progressbar === 'false' || this.getAutoPlay()) {
      this.dom.scrollbar.classList.add('no-scrollbar');
    }

    this.initSliderInResize();
    this.initSwiperBreakToLines();
  }

  addListeners() {
    window.addEventListener('resize', this.handleResize.bind(this));
  }

  initSliderInResize() {
    this.isDesktop = window.matchMedia('(max-width: 1025px)').matches;
    this.isMobile = window.matchMedia('(max-width: 677px)').matches;
    this.dom.slider.classList.remove('no-swiper--people-slider');
    this.dom.slider.classList.remove('no-swiper--insights');

    if (this.dom.items.length > this.getSlidesByScreenAndType()) {
      this.initSlider();
      this.el.style.visibility = 'visible';
    } else {
      if (this.isPeopleSlider) {
        this.dom.slider.classList.add('no-swiper--people-slider');
      } else {
        this.dom.slider.classList.add('no-swiper--insights');
      }

      this.el.style.visibility = 'visible';
    }

    if (this.swiper) {
      this.swiper.update();
    }
  }

  handleResize() {
    if (this.swiper) {
      if (this.originalWindowWidth === window.innerWidth) {
        return;
      }

      this.originalWindowWidth = window.innerWidth;
      this.swiper.destroy();
    }

    this.initSliderInResize();
  }

  getSlidesByScreenAndType() {
    if (this.isPeopleSlider) {
      if (this.isMobile) {
        return 1;
      }
      if (this.isDesktop) {
        return 3;
      }
      return 3;
    }

    if (!this.isPeopleSlider) {
      if (this.isMobile) {
        return 2;
      }
      if (this.isDesktop) {
        return 4;
      }
      return 4;
    }
  }

  getIfProgressbarExists() {
    return this.el.dataset.progressbar === 'true';
  }

  getAutoPlay() {
    return this.el.dataset.autoplay === 'true';
  }

  initSwiperBreakToLines() {
    [
      ...document.querySelectorAll('[data-module="swiperBreakToLines"]')
    ].forEach(element => new breakToLines(element));
  }

initSlider() {
    const settingsPeopleSlider = {
      slidesPerView: 1.2,
      breakpoints: {
        677: {
          slidesPerView: 3.2,
          spaceBetween: 40
        },
        1920: {
          slidesPerView: 3.6,
          spaceBetween: 40
        }
      }
    }

    const settingsPortraitSlider = {
      slidesOffsetBefore: this.isScrollbar ? 20 : 0,
      slidesOffsetAfter: this.isScrollbar ? 20 : 0,
      slidesPerView: 2.22,
      breakpoints: {
        677: {
          slidesPerView: 3.2,
          spaceBetween: 40,
          slidesOffsetBefore: this.isScrollbar ? 40 : 0,
          slidesOffsetAfter: this.isScrollbar ? 40 : 0
        },
        1300: {
          slidesPerView: 4.2,
          spaceBetween: 40,
          slidesOffsetBefore: this.isScrollbar ? 40 : 0,
          slidesOffsetAfter: this.isScrollbar ? 40 : 0
        },
        1600: {
          slidesPerView: 4.7,
          slidesOffsetBefore: this.isScrollbar ? this.getOffset() : 0,
          slidesOffsetAfter: this.isScrollbar ? this.getOffset() : 0
        },
        1920: {
          slidesPerView: 4.7,
          spaceBetween: 40,
          slidesOffsetBefore: this.isScrollbar ? 200 : 0,
          slidesOffsetAfter: this.isScrollbar ? 200 : 0
        }
      }
    }

    const settingsHomePortraitSlider = {
      slidesOffsetBefore: this.isScrollbar ? 20 : 0,
      slidesOffsetAfter: this.isScrollbar ? 20 : 0,
      slidesPerView: 2,
      breakpoints: {
        677: {
          slidesPerView: 3,
          spaceBetween: 40,
          slidesOffsetBefore: this.isScrollbar ? 40 : 0,
          slidesOffsetAfter: this.isScrollbar ? 40 : 0
        },
        1280: {
          slidesPerView: 4,
          spaceBetween: 40,
          slidesOffsetBefore: this.isScrollbar ? 40 : 0,
          slidesOffsetAfter: this.isScrollbar ? 40 : 0
        },
        1600: {
          slidesPerView: 5,
          slidesOffsetBefore: this.isScrollbar ? this.getOffset() : 0,
          slidesOffsetAfter: this.isScrollbar ? this.getOffset() : 0
        },
        1920: {
          slidesPerView: 6,
          spaceBetween: 40,
          slidesOffsetBefore: this.isScrollbar ? 200 : 0,
          slidesOffsetAfter: this.isScrollbar ? 200 : 0
        }
      }
    }

    let swiperSettings = {
      spaceBetween: 20,
      init: true,
      freeMode: true,
      autoplay: false,
      speed: 100,
      scrollbar: {
        el: this.dom.scrollbar,
        draggable: true
      }
    }

    if (this.isPeopleSlider) {
      swiperSettings = { ...swiperSettings, ...settingsPeopleSlider }
    } else if (this.isHomeSlider) {
      swiperSettings = { ...swiperSettings, ...settingsHomePortraitSlider }
    } else {
      swiperSettings = { ...swiperSettings, ...settingsPortraitSlider }
    }

    this.swiper = new Swiper(this.dom.slider, swiperSettings);
  }

  getOffset() {
    return (window.innerWidth - 1600) * 0.5 + 40;
  }
}

export default Module;
